import { enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { HttpLoaderFactory } from './app/app.module';
import { environment } from './environments/environment';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { BuscarFacturaPipe } from './app/pipes/buscar-factura';
import { BuscarAlbaranPipe } from './app/pipes/buscar-albaran';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient, HttpClient } from '@angular/common/http';
import { InterceptorService } from './app/services/interceptor/interceptor.service';
import { MbscDatepickerModule, MbscModule } from '@mobiscroll/angular';
import { FormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';

import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { InputsModule } from '@progress/kendo-angular-inputs';

import { AppComponent } from './app/app.component';
import { BuscarPedidoPipe } from './app/pipes/buscar-pedido.pipe';
import { BuscarPresupuestoPipe } from './app/pipes/buscar-presupuesto';
import { provideIonicAngular, IonicRouteStrategy  } from '@ionic/angular/standalone';
import  {routes} from './app/app-routing.module';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
         provideIonicAngular({
            innerHTMLTemplatesEnabled: true // Add here
         }),
         provideRouter(routes, withPreloading(PreloadAllModules)),

        importProvidersFrom( FormsModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }), ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }), ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }), AngularFireModule.initializeApp(environment.firebaseConfig), AngularFireStorageModule, AngularFireAuthModule),
        TitleCasePipe,
        DatePipe,
        BuscarFacturaPipe,
        BuscarAlbaranPipe,
        BuscarPedidoPipe,
        BuscarPresupuestoPipe,
        Diagnostic,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        { provide: LOCALE_ID, useValue: 'es-ES' },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
  .catch(err => console.log(err));
